import { ReactNode } from 'react'

const FilterRow = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-end">
      {children}
    </div>
  )
}

export { FilterRow }
